import React from 'react';
import { useClassNameMapper } from 'react-bootstrap';
import type { BadgeViewVariant, ItemType } from '../../../../types/enums';
import type { BadgeViewFragment } from '../../../../types/graphql-types';
import type { ItemViewVariantFC } from '../../../entities/types';
import localStyles from '../BadgeViewMain/BadgeViewMain.module.pcss';
import BadgeIcon from '@aurora/shared-client/components/badges/BadgeIcon/BadgeIcon';
import { IconSize } from '@aurora/shared-client/components/common/Icon/enums';

/**
 * Badge view main component to render the main badge in the badge set card.
 *
 * @constructor
 * @author Gaston Manzano
 */
const BadgeViewMain: ItemViewVariantFC<
  BadgeViewFragment,
  ItemType.BADGE,
  BadgeViewVariant.MAIN
> = ({ entity: badge, isEarned }) => {
  const cx = useClassNameMapper(localStyles);
  const { description, title, icon } = badge;

  return (
    <div data-testid={`Badge.Main.${isEarned ? 'Earned' : 'Unearned'}`} tabIndex={-1}>
      <BadgeIcon
        href={icon?.url}
        alt={title}
        className={cx(
          {
            'lia-badge-main-unearned': !isEarned
          },
          'lia-badge-main-icon'
        )}
        size={IconSize.PX_160}
      />
      <div
        className={cx(
          { 'lia-badge-main-information-unearned': !isEarned },
          'lia-badge-main-information'
        )}
        data-testid="Badge.Main.Information"
      >
        <h5>{title}</h5>
        {description && <small>{description}</small>}
      </div>
    </div>
  );
};

export default BadgeViewMain;
